import React, { useState } from 'react';
import { observer } from 'mobx-react';
import styles from './DeleteReviewModal.module.css';
import { Modal } from '../../../components/UI/Modal/Modal';
import { Button } from '../../../components/UI/Button/Button';
import { Review, ReviewAuthor } from '../../../models/reviews';

interface DeleteReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reviewId: string) => Promise<boolean>;
  review: Review | null;
}

export const DeleteReviewModal: React.FC<DeleteReviewModalProps> = observer(
  ({ isOpen, onClose, onConfirm, review }) => {
    const [loading, setLoading] = useState(false);

    const getAuthorName = (author: ReviewAuthor | undefined) => {
      if (!author) {
        return 'Анонимный пользователь';
      }
      if (author.first_name || author.last_name) {
        return [author.first_name, author.last_name].filter(Boolean).join(' ');
      }
      return 'Анонимный пользователь';
    };

    const handleConfirm = async () => {
      if (!review) {
        return;
      }

      setLoading(true);
      try {
        const success = await onConfirm(review.id);
        if (success) {
          onClose();
        }
      } catch (error) {
        // Ошибка обработается в родительском компоненте
      } finally {
        setLoading(false);
      }
    };

    if (!review) {
      return null;
    }

    return (
      <Modal isOpen={isOpen} onClose={onClose} title="Удалить отзыв">
        <div className={styles.content}>
          <div className={styles.warning}>
            <div className={styles.warningIcon}>⚠️</div>
            <div className={styles.warningText}>
              <h3>Вы уверены, что хотите удалить этот отзыв?</h3>
              <p>Это действие нельзя будет отменить.</p>
            </div>
          </div>

          <div className={styles.reviewInfo}>
            <div className={styles.reviewDetail}>
              <strong>Автор:</strong> {getAuthorName(review.author)}
            </div>
            <div className={styles.reviewDetail}>
              <strong>Заголовок:</strong>{' '}
              {review.translations?.[0]?.title || 'Без заголовка'}
            </div>
          </div>

          <div className={styles.actions}>
            <Button
              type="button"
              appearance="link"
              onClick={onClose}
              disabled={loading}
            >
              Отмена
            </Button>
            <Button
              type="button"
              appearance="auth"
              onClick={handleConfirm}
              disabled={loading}
              style={{ backgroundColor: '#dc3545' }}
            >
              {loading ? 'Удаление...' : 'Удалить отзыв'}
            </Button>
          </div>
        </div>
      </Modal>
    );
  },
);
